import React from 'react'
import SpesialisService from '../Service/spesialisService'
import FormInput from './formInput'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import ConfirmDel from './modalHapus'
import {config} from '../Config/config'

export default class index extends React.Component {
    SpesialisModel = {
        _id: "",
        name: "",
        create_by: localStorage.getItem(config.userid),
        create_on: "",
        modified_by: localStorage.getItem(config.userid),
        modified_on: "",
        deleted_by: localStorage.getItem(config.userid),
        deleted_on: "",
        is_delete: false
    }

    constructor() {
        super()
        this.state = {
            List: [],
            ListSpesialis: [],
            Model: this.SpesialisModel,
            Mode: "",
            ShowModal: false,
            ShowModalDel: false,
            errors: {},
            filter: {
                search: '',
                order: '',
                page: '1',
                pagesize: '3',
            },
            TotalPage: 0,
            currentPage: 1
        }
    }

    //untuk manggil semua data yang ada di db
    loadList = async () => {
        const respon = await SpesialisService.getAllData(this.state.filter)
        // const respon = await SpesialisService.getFilter(this.state.filter)
        const responCount = await SpesialisService.countData()
        // console.log(responData)
        if (respon.success) {
            let count = responCount.result.jumlah
            this.setState({
                List: respon.result,
                TotalPage: Math.ceil(count / this.state.filter.pagesize)
            })
        }
    }

    loadListCari = async () => {
        // const respon = await SpesialisService.getAll()
        const respon = await SpesialisService.getFilter(this.state.filter)
        // console.log(respon.result)
        const responCount = await SpesialisService.countData()
        const responSpesialis = await SpesialisService.getAll()
        // const jumlahPage = respon.jumlah
        // console.log(this.state.Model)
        if (respon.success) {
            let count = respon.result[0]
            if (count != null) {
                let hitung = count.jumlah
                // console.log(hitung)
                this.setState({
                    List: respon.result,
                    ListSpesialis: responSpesialis.result,
                    TotalPage: Math.ceil(hitung / this.state.filter.pagesize)
                })
            } else {
                let hitung = 0
                this.setState({
                    List: respon.result,
                    ListSpesialis: responSpesialis.result,
                    TotalPage: Math.ceil(hitung / this.state.filter.pagesize)
                })
            }

        }
    }


    //pertama kali ditampilkan akan muncul loadlist
    componentDidMount() {
        // this.loadList()
        this.loadListCari()
    }

    createHandler = () => {
        this.setState({
            Mode: "Tambah",
            ShowModal: true,
            Model: this.SpesialisModel
        })
    }


    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModal: false,
            ShowModalDel: false
        })
    }

    handleValidation = () => {
        let Fields = this.state.Model;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!Fields["name"].trim()) {
            formIsValid = false;
            errors["name"] = "Data Tidak Boleh Kosong";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }


    //fungsi untuk ngisi chekbox
    changeHandler = name => ({ target: { value } }) => {
        //setState untuk mengupdate
        this.setState({
            Model: {
                ...this.state.Model,
                [name]: value
            }
        })
    }

    //button submit supaya data yang sudah di input dapat di save
    saveHandler = async () => {
        //dicek terlebih dahulu apakah mode bertipe edit atau bukan
        if (this.handleValidation()) {
            if (this.state.Mode == "Ubah") {
                this.state.Model.modified_by = localStorage.getItem(config.userid)
                const respon = await SpesialisService.EditData(this.state.Model)
                if (respon.success) {
                    // alert("Succes Update Data")
                    // this.loadList()
                    this.loadListCari()
                    this.setState({
                        Model: this.SpesialisModel,
                        ShowModal: false
                    })
                }
            } else if (this.state.Mode == "Hapus") {
                this.state.Model.modified_by = localStorage.getItem(config.userid)
                this.state.Model.deleted_by = localStorage.getItem(config.userid)
                this.state.Model.is_delete = true
                const respon = await SpesialisService.EditDDelete(this.state.Model)
                if (respon.success) {
                    // alert("Succes Hapus Data")
                    // this.loadList()
                    this.loadListCari()
                    this.setState({
                        Model: this.SpesialisModel,
                        ShowModalDel: false
                    }, () => this.loadListCari())
                }
            } else {
                const respon = await SpesialisService.addData(this.state.Model)
                // console.log(respon.result)
                if (respon.success) {
                    // alert("Succes Save Data")
                    // this.loadList()
                    this.loadListCari()
                    this.setState({
                        Model: this.SpesialisModel,
                        ShowModal: false
                    })
                }
            }
        } 
        // else {
        //     alert("Errors")
        // }
    }

    //untuk mengambil data sesuai dengan id nya. penulisan id harus sesuai dengan di db
    editHandler = async (_id) => {
        const respon = await SpesialisService.getById(_id)
        // console.log(respon)

        this.setState({
            //membuat mode menjadi edit
            Mode: "Ubah",
            ShowModal: true
        })

        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    //hapus data (ubah is_delete)
    hapusHandler = async (_id) => {
        const respon = await SpesialisService.getById(_id)

        this.setState({
            //membuat mode menjadi edit
            Mode: "Hapus",
            ShowModalDel: true
        })

        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    //filter
    filterHandler = field => ({ target: { value } }) => {
        //setState untuk mengupdate
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        }, () => this.loadListCari())

    }

    changePageHandler = (number) => {
        // console.log(this.state.filter)
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            },
            currentPage: number
        }, () => this.loadListCari())
    }

    changePage = (direction) => {
        if (direction == 'back') {
            this.setState({
                currentPage: this.state.currentPage - 1
            });
            this.changePageHandler(this.state.currentPage - 1)
        } else if (direction == 'next') {
            this.setState({
                currentPage: this.state.currentPage + 1
            });
            this.changePageHandler(this.state.currentPage + 1)
        }
    }

    konfirmHandler = () => {
        this.setState({
            // Mode: "Tambah",
            ShowModalDel: true,
            // Model: this.DarahModel
        })
    }

    //untuk dapet banyak nya page
    renderPagination() {
        let item = []
        {
            this.state.currentPage > 1 ?
                item.push(
                    <PaginationItem key={0}>
                        <PaginationLink onClick={() => this.changePage("back")}>
                            Back
                </PaginationLink>
                    </PaginationItem>
                ) : null
        }
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        {
            this.state.currentPage < this.state.TotalPage ?
                item.push(
                    <PaginationItem>
                        <PaginationLink onClick={() => this.changePage("next")}>
                            Next
                </PaginationLink>
                    </PaginationItem>
                ) : null
        }
        return (
            <Pagination>
                {item}
            </Pagination>
        )
    }


    render() {
        const { List, Model, ShowModal, errors, Mode, ShowModalDel, ListSpesialis } = this.state
        // console.log(List)
        // console.log(ListSpesialis)
        return (
            <div class="bg-white">
                {/* {JSON.stringify(this.state.Model)} */}
                <table class="table">

                    <thead class="bg-primary">
                        <div style={{ height: 30 }}>
                            <h4 class="page-title font-weight-bold text-black">SPESIALIS</h4>
                        </div>
                    </thead>

                    <tbody>
                        <table class="table" align="center" style={{ width: 1000 }}>

                            <thead>
                                {/* <div class="row m-t-20"> */}

                                {/* <div class="col-sm-4 col-10">
                                        <div class="card-tools">
                                            <div class="input-group input-group-sm" >
                                                <input type="text" name="table_search" class="form-control float-right" placeholder="Search by name" onChange={this.filterHandler("search")} />
                                                <div class="input-group-append">
                                                    <button type="submit" class="btn btn-primary" onClick={() => this.loadList()} ><i class="fa fa-search"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                {/* <div class="col-sm-8 col-2 m-b-20">
                                        <div class="float-right" >
                                        <button class="btn btn-primary float-right" onClick={this.createHandler}> Tambah </button>
                                        </div>
                                    </div> */}
                                {/* </div> */}

                                <tr>
                                    <th>
                                        <input style={{ width: 200 }} type="text" name="table_search" class="form-control" placeholder="Search by name" onChange={this.filterHandler("search")} />
                                    </th>
                                    <th>
                                        <button class="btn btn-primary float-right" onClick={this.createHandler}> Tambah </button>
                                    </th>
                                </tr>

                                <tr class="text-center bg-primary">
                                    <th scope="col">Nama</th>
                                    <th scope="col">Nama User</th>
                                    <th scope="col">#</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    //map untuk looping di dalam array
                                    List.map(data => {
                                        return (
                                            ListSpesialis.map(spesialis => {
                                                if (data.id_spesialis == spesialis._id) {
                                                    return (
                                                        <tr class="text-center">
                                                            <td>{spesialis.name}</td>
                                                            <td>{spesialis.user}</td>
                                                            <td>
                                                                <button class="btn btn-primary" onClick={() => this.editHandler(spesialis._id)}>U</button>
                                                                <button class="btn btn-danger" onClick={() => this.hapusHandler(spesialis._id)}>H</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            })
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </tbody>

                </table>
                <div class="float-right">
                    {this.renderPagination()}
                </div>

                <FormInput changeHandler={this.changeHandler}
                    saveHandler={this.saveHandler}
                    cancelHandler={this.cancelHandler}
                    showModal={ShowModal}
                    Errors={errors}
                    mode={Mode}
                    Model={Model} />
                <ConfirmDel
                    ShowModalDel={ShowModalDel}
                    cancelHandler={this.cancelHandler}
                    saveHandler={this.saveHandler}
                    Model={Model}
                />

            </div>
        )
    }
}